<template>
  <el-dialog
    title="选择商品"
    :visible.sync="chooseGoodDia"
    width="1000px"
    style="text-align: left"
    :close-on-click-modal="false"
    append-to-body
    class="big"
    :show-close="isShowClose"
    :before-close="close"
  >
    <div class="content">
      <div>
        <span style="margin-left: 20px">商品：</span>
        <el-input
          v-model="keywords"
          placeholder="请输入商品"
          size="small"
          maxlength="20"
          style="width: 200px"
        ></el-input>
        <span style="margin-left: 20px">商品活动类型：</span>
        <el-select
          v-model="act_type_id"
          size="small"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in actTypeOptions"
            :key="item.act_type_id"
            :label="item.act_type_name"
            :value="item.act_type_id"
          >
          </el-option>
        </el-select>
        <el-button
          type="primary"
          @click="getList"
          size="small"
          style="margin-left: 20px"
          >查询</el-button
        >
      </div>

      <div class="table_list">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          height="500"
          style="width: 100%"
          :header-cell-style="{ background: '#F5F5F5' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column v-if="chooseType == 2" type="selection" width="55">
          </el-table-column>
          <el-table-column label="商品" width="300">
            <template slot-scope="scope">
              <div class="flex between" style="width: 300px">
                <el-image
                  :src="scope.row.picture"
                  :preview-src-list="[scope.row.picture]"
                  style="width: 100px; height: 100px"
                />
                <div style="width: 180px">
                  <div>{{ scope.row.goods_name }}</div>
                  <div style="color: #ea6528">¥ {{ scope.row.price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="商品价格" width="140">
            <template slot-scope="scope">
              {{ scope.row | priceText }}
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" />
          <el-table-column
              prop="act_type_name"
              label="商品活动类型"
              width="160"
            >
            </el-table-column>
          <el-table-column v-if="chooseType == 1" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="submit(scope.row)"
                >选择当前商品</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <template v-if="chooseType == 2">
        <el-button @click="close" plain>取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </template>
    </span>
  </el-dialog>
</template>
<script>
import common from "@/api/common.js";
export default {
  props: {
    chooseGoodDia: {
      type: Boolean,
      require: true,
    },
    chooseType: {
      type: Number,
      require: true,
      default: 1,
    },
    isShowClose: {
      type: Boolean,
      require: false,
    },
    paramsType: {
      type: Number,
      require: true,
      default: 4,
    },
  },
  data() {
    return {
      keywords: "",
      act_type_id:'',
      page: 1,
      total: 0,
      list: [],
      checkGoods: {},
      selection: [],
      actTypeOptions: [],
    };
  },
  filters: {
    priceText(val) {
      if (!val.sku_list.length) {
        return val.price;
      } else if (val.sku_max_price == val.sku_min_price) {
        return val.sku_min_price;
      } else {
        return `${val.sku_min_price} - ${val.sku_max_price}`;
      }
    },
  },
  watch: {
    chooseGoodDia: {
      handler: async function (n) {
        if (n) {
          this.selection = [];
          await this.getActTypeOptions();
          this.getList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 获取商品活动类型
    getActTypeOptions() {
      common.goodsActType().then((res) => {
        const { code, data } = res;
        if (code === 0) {
          this.actTypeOptions = data.list || [];
        }
      });
    },
    getList() {
      let data = {
        keywords: this.keywords,
        type: this.paramsType,
        act_type_id: this.act_type_id,
        pageNumber: 99999999999999,
      };
      this.axios
        .post("platform/shop/getShopActivityGoodsList", data)
        .then((res) => {
          this.list = res.data.list;
        });
    },
    close() {
      this.$emit("update:chooseGoodDia", false);
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    submit(row) {
      // this.$emit('checkGoods', this.selection);
      this.$emit("checkGoods", this.chooseType == 1 ? row : this.selection);
      this.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 20px 20px 0;
  box-sizing: border-box;
}
.list-box {
  height: 400px;
  overflow: auto;
  margin-top: 15px;
  & > div {
    margin-bottom: 10px;
  }
  img {
    height: 70px;
    width: auto;
    margin: 0 15px;
  }
}
.table_list {
  border: solid 1px #c9cbd6;
  margin-top: 20px;
}
</style>
